import React from "react";
import Parser from "html-react-parser";
// @ts-ignore
import Context from "@fdr-mar/promos-context";
import { useMediaQuery, breakpoints } from "@tvg/design-system";
import { Header, Paragraph } from "@tvg/design-system/web";
import OptinButton from "../OptinButton";
import {
  PromosBannerContentWrapper,
  PromosBannerContentContainer,
  PromoBannerButtonWrapper
} from "./styled-components";
import { PromosBannerContentProps } from "./types";

const { PathContext } = Context;

const PromosBannerContent = ({
  promosBannerItem = {
    config: {
      ctaLabel: "",
      linkLabel: "",
      path: { id: "", url: "", cached_url: "", linktype: "url" },
      segment: "all",
      promoCode: "",
      displayCTA: false,
      forOptin: false,
      enablePromoCode: false,
      promoId: "12345"
    },
    categoryTitle: "",
    description: "",
    title: ""
  }
}: PromosBannerContentProps) => {
  const isMobile = useMediaQuery(breakpoints.desktop.max.sm);

  const renderButton = (slug: string) => {
    const { ctaLabel, forOptin, linkLabel, path, segment, promoCode } =
      promosBannerItem.config;
    const buttonProps = {
      ctaLabel,
      forOptin,
      linkLabel,
      path,
      isForBanner: true,
      segment,
      promoCode
    };

    return (
      <PromoBannerButtonWrapper promosPage={slug === "promos"}>
        <OptinButton content={buttonProps} />
      </PromoBannerButtonWrapper>
    );
  };

  const { displayCTA } = promosBannerItem.config;

  return (
    <PathContext.Consumer>
      {(path: { currentSlug: string }) => (
        <PromosBannerContentContainer
          data-qa-label="promosBannerContentContainer"
          promosPage={path.currentSlug === "promos"}
        >
          <PromosBannerContentWrapper>
            <Header
              tag="h3"
              qaLabel="promo-banner-title"
              fontFamily="medium"
              color="--fd-colors-brand-tertiary-default"
              textTransform="uppercase"
            >
              <>{Parser(promosBannerItem.categoryTitle)}</>
            </Header>
            <Paragraph
              qaLabel="PromosBannerContentTitle"
              fontFamily="bold"
              fontSize={isMobile ? 16 : 40}
              color="--fd-colors-content-on-dark"
              lineHeight="125%"
            >
              <>{Parser(promosBannerItem.title)}</>
            </Paragraph>
            <Paragraph
              qaLabel="PromosBannerContentDescription"
              fontFamily="regular"
              fontWeight={500}
              fontSize={isMobile ? 14 : 18}
              color="--fd-colors-content-on-dark"
              lineHeight="125%"
            >
              <>{Parser(promosBannerItem.description)}</>
            </Paragraph>
            {displayCTA && renderButton(path.currentSlug)}
          </PromosBannerContentWrapper>
        </PromosBannerContentContainer>
      )}
    </PathContext.Consumer>
  );
};

export default PromosBannerContent;
